import type { DevEnv } from "@p0security/shared/types/environment";

import type { AwsPartition } from "../util.ts";
import type { AwsPolicyOptions } from "./policies.ts";
import { roleInstallCommands, roleTerraform } from "./shared.ts";

export const accessLogsInstallCommands = (
  context: DevEnv,
  options: AwsPolicyOptions,
  args: {
    gcloudServiceAccountId: string;
    awsAccountId: string;
    awsPartition: AwsPartition;
  }
) => {
  const roleSetupCommands = roleInstallCommands(
    "access-logs",
    context,
    options,
    args
  );

  return `${roleSetupCommands}`;
};

export const accessLogsTerraform = (
  context: DevEnv,
  options: AwsPolicyOptions,
  gcloudServiceAccountId: string,
  awsPartition: AwsPartition
) => {
  const roleSetupTerraform = roleTerraform(
    "access-logs",
    context,
    options,
    gcloudServiceAccountId,
    awsPartition
  );
  return `${roleSetupTerraform}`;
};
